import { render, staticRenderFns } from "./outOrderManage.vue?vue&type=template&id=2f706b1f&scoped=true"
import script from "./outOrderManage.vue?vue&type=script&lang=js"
export * from "./outOrderManage.vue?vue&type=script&lang=js"
import style0 from "./outOrderManage.vue?vue&type=style&index=0&id=2f706b1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f706b1f",
  null
  
)

export default component.exports